import { Add } from '@mui/icons-material';
import { Card, CardContent, Collapse, List } from '@mui/material';
import _ from 'lodash';
import { FC, useState } from 'react';

import { CardTitleWithEdit } from '../../../../../components/cardTitleWithEdit/CardTitleWithEdit';
import { useAppSelector } from '../../../../../state/redux.hooks';
import { useMitarbeiterRole } from '../../../../auth/api/auth.hook';
import { selectMitarbeiterId } from '../../../../auth/api/authSlice';
import { MitarbeiterRole } from '../../../../auth/api/types';
import { Projekt } from '../../../api/projekt.types';
import { useFindAllProjektMitarbeiterQuery } from '../../../api/projektApi';

import { ProjektMitarbeiterForm } from './ProjektMitarbeiterForm';
import { ProjektMitarbeiterListItem } from './ProjektMitarbeiterListItem';

export const ProjektMitarbeiterCard: FC<{ projekt: Projekt }> = ({ projekt }) => {
  const userRole = useMitarbeiterRole();
  const currentUserId = useAppSelector(selectMitarbeiterId);

  const { data } = useFindAllProjektMitarbeiterQuery({
    filter: {
      projektId: {
        value: projekt.id,
        operator: 'equal',
      },
    },
  });

  const [showAddMitarbeiterForm, setShowAddMitarbeiterForm] = useState(false);
  const toggleMitarbeiterForm = () => setShowAddMitarbeiterForm(p => !p);

  const excludeMitarbeiterIds = data?.data.map(({ mitarbeiterId }) => mitarbeiterId) ?? [];

  const isIntern = userRole === MitarbeiterRole.INTERN;
  const isAdmin = userRole === MitarbeiterRole.ADMIN;
  const isInternAlreadyAssigned =
    isIntern && !!currentUserId && excludeMitarbeiterIds.includes(currentUserId);

  const canAddOrSelfAssign = isAdmin || (isIntern && !isInternAlreadyAssigned);

  return (
    <Card>
      <CardContent>
        <CardTitleWithEdit
          title={'Projektmitarbeiter'}
          optionLabel={isIntern ? 'Dem Projekt beitreten' : 'Projektmitarbeiter hinzufügen'}
          optionIcon={<Add />}
          onClickEdit={canAddOrSelfAssign ? toggleMitarbeiterForm : undefined}
        />
        <List dense>
          <Collapse in={showAddMitarbeiterForm && canAddOrSelfAssign}>
            <ProjektMitarbeiterForm
              istPauschal={projekt.istPauschal}
              key={'projekt-mitarbeiter-form'}
              saveMode="create"
              onClose={toggleMitarbeiterForm}
              createProjektMitarbeiterDTOinitialValues={{ projektId: projekt.id }}
              excludeMitarbeiterIdsFromAutocomplete={excludeMitarbeiterIds}
            />
          </Collapse>
          {data &&
            _.sortBy(data.data, ({ mitarbeiterId }) =>
              mitarbeiterId === projekt.projektLeiterId ? 0 : 1
            ).map((pM, index) => (
              <ProjektMitarbeiterListItem
                istPauschal={projekt.istPauschal}
                key={pM.id}
                isProjektleiter={index === 0}
                projektMitarbeiter={pM}
              />
            ))}
        </List>
      </CardContent>
    </Card>
  );
};
